import { useQuery } from '@apollo/client';
import { Select } from 'antd';
import React, { useState } from 'react';
import { GET_BUYER_TYPE, } from 'Util/queries';
const { Option } = Select;

function BuyerTypeDropdown({ onChange, value, ...rest }) {
    const [list, setList] = useState([])

    const { data } = useQuery(GET_BUYER_TYPE, {
        onCompleted() {
            setList(data?.buyer_db.buyer_type)
        }
    });

    return (
        <div>
            <Select
                {...rest}
                placeholder="Select a type"
                onChange={onChange}
                value={value}
            >
                {list.map(v => <Option value={v.id} key={`type-dd-opt${v.id}`}>{v.label}</Option>)}
            </Select>
        </div>
    )
}

export default BuyerTypeDropdown
